import { render, staticRenderFns } from "./PhraseLink.vue?vue&type=template&id=9da2bd26&scoped=true"
import script from "./PhraseLink.vue?vue&type=script&lang=ts"
export * from "./PhraseLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da2bd26",
  null
  
)

export default component.exports